import { oidcConfig } from '../forgeiam/authConfig'

interface StoredOidcProfile {
  name?: string
  customer?: string
}

interface StoredOidcUser {
  id_token?: string
  profile?: StoredOidcProfile
}

export const getStoredOidcUser = (): StoredOidcUser | null => {
  const itemKey = `oidc.user:${oidcConfig.authority ?? ''}:${oidcConfig.client_id ?? ''}`
  const itemValue = sessionStorage.getItem(itemKey)

  if (itemValue == null || itemValue.trim() === '') {
    return null
  }

  try {
    return JSON.parse(itemValue) as StoredOidcUser
  } catch {
    return null
  }
}

export const getStoredUsername = (): string => {
  return String(getStoredOidcUser()?.profile?.name ?? '')
}

export const getStoredTenantId = (): string => {
  return String(getStoredOidcUser()?.profile?.customer ?? '')
}
